import LiveCasinoHome from "./views/LiveCasinoHome.vue";
import LiveCasinoExtractions from "./views/LiveCasinoExtractions.vue";
import LiveCasinoSpins from "./views/LiveCasinoSpins.vue";
import Players from "../slot/views/Players.vue";
import Exports from "../views/Exports.vue";
import Chat from "../views/Chat.vue";

export const liveCasinoRoutes = [
  {
    path: "/:lang?/:skinFilt(\\d+)?/livecasino",
    component: LiveCasinoHome,
    meta: { requiresAuth: true, hiddenBreadcrumb: true, section: "livecasino" },
    name: "LiveCasinoHome",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/livecasino/extractions",
    name: "LiveCasinoExtractionsPage",
    component: LiveCasinoExtractions,
    meta: { requiresAuth: true, section: "livecasino" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/livecasino/spins",
    name: "LiveCasinoSpinsPage",
    component: LiveCasinoSpins,
    meta: { requiresAuth: true, section: "livecasino" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/livecasino/players/:id?",
    name: "LiveCasinoPlayersPage",
    component: Players,
    meta: { requiresAuth: true, section: "livecasino" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/livecasino/export",
    name: "LiveCasinoExportPage",
    component: Exports,
    meta: { requiresAuth: true, section: "livecasino" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/livecasino/chat",
    component: Chat,
    name: "LiveCasinoChatPage",
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "livecasino",
    },
  },
];
